__turbopack_context__.v({
  "checkbox": "checkbox-module-scss-module__KF_roa__checkbox",
  "control": "checkbox-module-scss-module__KF_roa__control",
  "errorMessage": "checkbox-module-scss-module__KF_roa__errorMessage",
  "input": "checkbox-module-scss-module__KF_roa__input",
  "isError": "checkbox-module-scss-module__KF_roa__isError",
  "isNoLabel": "checkbox-module-scss-module__KF_roa__isNoLabel",
  "label": "checkbox-module-scss-module__KF_roa__label",
  "optional": "checkbox-module-scss-module__KF_roa__optional",
});
